import { ApplicationController } from "../application_controller";

// Sorting select of a Tabulator list shown as cards on phones and tablets (shared/_mobile_sort):
// the value is "<field>|<asc or desc>", the table is found by data-layout--mobileSort-table.
export default class extends ApplicationController {
  static targets = ["select"]

  sort() {
    const table = document.querySelector(this.data.get("table"));
    if (!table || !table.tabulator) return;

    const [field, dir] = this.selectTarget.value.split("|");
    table.tabulator.setSort(field, dir);
  }
}
